import React, { useRef } from 'react';
import './Name.scss';
import { Text } from '../text/Text.tsx';
import Keycap from '../keycap/Keycap.tsx';
import './Home.scss';

export const Name: React.FC = () => {
  const handleDownloadCV = () => {
    const FILE_ID = "1Uf2tdiayMzJYxR8PNT0xYDDRL9DATYIv";
    const downloadUrl = `https://drive.google.com/uc?export=download&id=${FILE_ID}`;
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'SonDang_CV.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="name">
      <div>
        <div className="name-content">
          <Text style={{ fontWeight: 'bold', fontSize: 36 }} variant="body">
            {'Son Dang'}
          </Text>
        </div>

        <div>
          <Text variant="body">{'Occupation: '}</Text>
          <Text style={{ fontWeight: 'bold' }} variant="body">
            {'Mobile Developer / Newbie designer'}
          </Text>
        </div>

        <div style={{ marginBottom: 16 }}>
          <Text variant="body">{'Location: '}</Text>
          <Text style={{ fontWeight: 'bold' }} variant="body">
            {'Ho Chi Minh City, Vietnam'}
          </Text>
        </div>
        <div style={{ marginBottom: 16 }} className="italic typing">
          <Text variant="bodySecondary">
            {'a Developer with design eyes & nearsighted..'}
          </Text>
        </div>
        <div style={{ display: 'flex', gap: 12, flexDirection: 'row' }}>
          <Keycap
            content={'Inbox me'}
            onClick={() => {
              window.open('mailto:danghuyson@outlook.com');
            }}
          />
          <Keycap
            content={'Download CV'}
            theme={'fun'}
            onClick={handleDownloadCV}
          />
        </div>
      </div>
    </div>
  )
};
